export default __webpack_public_path__ + "static/media/794.27536ec0.png";